import { createNode } from '@glueapp/graph-types';

export const Cosine = createNode({
    id: 'Cosine',
    name: 'Cosine',
    description: 'Gives the cosine of the value',
    aiDescription:
        'Computes the cosine of a number (in radians). Connect a value to the "Value" input port; the "Result" output port provides the cosine.',
    category: 'Math',
    color: '#5daa5b',
    integration: undefined,
    inPorts: {
        Value: {
            kind: 'number',
        },
    },
    outPorts: {
        Result: {
            kind: 'number',
        },
    },
    execute: function (input) {
        return { output: { Result: Math.cos(input.inPorts.Value) } };
    },
});
